<template>
  <div>
    <div
      class="youtube-btn-wrap">
      <div
        class="youtube-search-wrap"
        style="margin-bottom: 22px;">
        <input
          v-model="videoId"
          class="youtube-search"
          placeholder="動画ID"
          type="search"
          @search="onClickedSearch('', $event)"
          @keydown.prevent.enter="onClickedSearch('enter', $event)">
        <a
          class="c-btn c-btn--search"
          @click.prevent="onClickedSearch('',$event)">
          <img src="/img/common/icon-search.png" />検索
        </a>
      </div>
    </div>
    <claim-table
      v-if="claims.length > 0"
      :items="claims"
      @row-clicked="onClaimRowClicked" />
    <div
      v-else-if="errorMessage"
      class="error-message">
      {{ errorMessage }}
    </div>
  </div>
</template>

<script>
import YouTubeClaimsClaimTable from './ClaimTable'

export default {
  name: 'YouTubeClaimsVideoSearch',
  components: {
    ClaimTable: YouTubeClaimsClaimTable,
  },
  props: {
    inputVideoId: {
      type: String,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      videoId: '',
      claims: [],
      error: null,
      errorMessage: null,
    }
  },
  watch: {
    inputVideoId: {
      handler(value) {
        if (this.videoId !== value) {
          this.videoId = value
          if (this.videoId) {
            this.fetchItems(value)
          }
        }
      },
      immediate: true,
    },
  },
  mounted() {
    // this.fetchItems(this.inputVideoId)
  },
  methods: {
    async onClickedSearch(type, event) {
      if (type === 'enter' && event.keyCode !== 13) {
        return
      }
      if (this.videoId === '' || this.videoId === null) {
        this.claims = []
        this.modalVideoId = null
        return
      }
      this.errorMessage = null
      this.claims = []
      this.modalVideoId = null
      this.error = null
      this.$emit('change', this.videoId)

      await this.fetchItems(this.videoId)
    },
    async fetchItems(videoId) {
      try {
        // 検索結果を取得
        const { data } = await window.axios.get('/api/client/youtube/claims/search', {
          params: {
            video_id: videoId,
          },
        })
        this.claims = data.items
      } catch (e) {
        const { response } = e
        const { status } = response
        if (status === 404) {
          this.claims = []
          this.errorMessage = '検索結果が見つかりませんでした'
        }
        this.error = e
      }
    },
    onClaimRowClicked(id) {
      this.$emit('row-clicked', id)
    },
  },
}
</script>

<style scoped>
.error-message {
  color: #ff0000;
  font-size: 16px;
  margin: 20px auto 120px 20px;
  text-align: left;
}
</style>
